import { Component, Input, OnInit } from '@angular/core';
import { AdUnitNote } from '../../../shared/domain/ad-unit-note.model';
import { User } from '../../../shared/domain/users/user.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdStatsBridgeAdUnitsService } from '../../../shared/services/ad-stats-bridge-ad-units.service';
import { Principal } from '../../../shared/auth/principal.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { AddEditNoteDialogComponent } from '../../../shared/components/dialogs/add-edit-note-dialog.component';
import { ConfirmDialogComponent } from '../../../shared/components/dialogs/confirm-dialog.component';
import { ServerErrorUtils } from '../../../shared/utils/server-error-utils';

@Component({
  selector: 'cm-ad-unit-notes',
  template: `
    <div class="cm-note-list" [hidden]="!notes?.length">
      <div class="cm-note-row" *ngFor="let note of notes">
        <div class="cm-note">
          <p>{{note.note}}</p>
          <div class="cm-note-footer">
            <small class="cm-note-details text-muted">{{note.createdOn | date:'MM/dd/yyyy @ HH:mm'}} by {{note.user}}</small>
            <button *ngIf="currentUser.email === note.user" mat-icon-button [matMenuTriggerFor]="menu" class="cm-note-control">
              <i class="far fa-ellipsis-v"></i>
            </button>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openEditDialog(note)">
              <i class="far fa-pencil"></i>
              <span>Edit note</span>
            </button>
            <button mat-menu-item color="warn" (click)="openDeleteDialog(note)">
              <i class="far fa-trash-alt"></i>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./ad-unit-notes.component.scss']
})
export class AdUnitNotesComponent implements OnInit {

  @Input()
  adUnitId: string;
  notes: AdUnitNote[];
  currentUser: User;
  loading = true;

  constructor(private matDialog: MatDialog,
              private service: AdStatsBridgeAdUnitsService,
              private principalService: Principal,
              private sbs: SnackBarService,
              private gss: GlobalSpinnerService) {
  }

  ngOnInit(): void {
    this.currentUser = this.principalService.getUser();
    this.refresh();
  }

  refresh() {
    this.loading = true;
    this.service.adUnitsNoteGet(this.adUnitId).subscribe(next => {
      this.loading = false;
      this.notes = next;
    }, () => {
      this.loading = false;
    });
  }

  openEditDialog(note: AdUnitNote) {
    this.matDialog.open(AddEditNoteDialogComponent, <MatDialogConfig>{
      width: '600px',
      data: {
        note: note.note
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.gss.showLoader();
        note.note = result;
        this.service.adUnitsNotePut(note).subscribe(next => {
          this.gss.hideLoader();
          this.sbs.success('Note updated successfully');
        }, error => {
          this.gss.hideLoader();
        });
      }
    });
  }

  openDeleteDialog(note: AdUnitNote) {
    this.matDialog.open(ConfirmDialogComponent).afterClosed().subscribe(result => {
      if (result) {
        this.gss.showLoader();
        this.service.adUnitsNoteDelete(note).subscribe(next => {
          this.gss.hideLoader();
          this.sbs.success('Note deleted successfully');
          this.notes = this.notes.filter(item => item.id !== note.id); // remove deleted note from view
        }, error => {
          this.gss.hideLoader();
        });
      }
    });
  }

  openNewNoteDialog() {
    this.matDialog.open(AddEditNoteDialogComponent, <MatDialogConfig>{
      width: '600px',
    }).afterClosed().subscribe(result => {
      if (result) {
        const adUnitNote = new AdUnitNote();
        adUnitNote.adUnitId = this.adUnitId;
        adUnitNote.note = result;
        this.gss.showLoader();
        this.service.adUnitsNotePost(this.adUnitId, adUnitNote).subscribe(() => {
          this.gss.hideLoader();
          this.sbs.success('Note added successfully');
          this.refresh();
        }, (e) => {
          ServerErrorUtils.serverValidationOrMsg(e, this.sbs, 'Note adding failed');
          this.gss.hideLoader();
        });
      }
    });
  }

}
